import { fetchWithAuth } from "./fetchWithAuth";

export interface NotificationHistoryItem {
  notificationId: string; recipientUserId: string; schemaVersion: number; eventType: string; category: string;
  createdAt: string; readAt: string | null; summaryKey: string; targetAvailable: boolean;
  target: { kind: string; contactId?: string; invitationId?: string; childUserId?: string } | null;
  currentState?: number | null;
  context?: { previousState?: number; newState?: number; invitationTypeId?: number; courseId?: string; isJoinRequest?: boolean } | null;
}
export interface NotificationHistoryPage { items: NotificationHistoryItem[]; nextCursor: string | null; totalUnreadCount: number; snapshot: string }
export function canonicalNotificationHint(value: unknown, owner: string): "legacy" | "canonical" | "invalid" {
  if (!value || typeof value !== "object") return "invalid";
  const message = value as Record<string, unknown>;
  const data = message.data && typeof message.data === "object" ? message.data as Record<string, unknown> : {};
  if (message.to && message.to !== owner || data.userId && data.userId !== owner) return "invalid";
  const id = message.notificationId ?? data.notificationId;
  const version = message.schemaVersion ?? data.schemaVersion;
  const event = message.eventType ?? data.eventType;
  if (id === undefined && version === undefined && event === undefined) return "legacy";
  return typeof id === "string" && /^[a-f0-9]{64}$/i.test(id) && (version === 1 || version === "1") &&
    typeof event === "string" && ["message.received", "invitation.received", "invitation.managed.received", "invitation.accepted", "invitation.updated", "account.plan.changed"].includes(event)
    ? "canonical" : "invalid";
}
export const notificationHistoryApi = {
  list: () => fetchWithAuth("/api/notifications?pageSize=20") as Promise<NotificationHistoryPage>,
  detail: (id: string) => fetchWithAuth(`/api/notifications/${encodeURIComponent(id)}`) as Promise<NotificationHistoryItem>,
  read: (id: string) => fetchWithAuth(`/api/notifications/${encodeURIComponent(id)}/read`, "POST"),
  readAll: (snapshot: string) => fetchWithAuth("/api/notifications/read-all", "POST", { snapshot }),
};